
import { supabase } from "@/integrations/supabase/client";

export interface AuditLogEntry {
  user_id?: string;
  action: string;
  resource_type: string;
  resource_id?: string;
  metadata?: Record<string, any>;
  ip_address?: string;
  user_agent?: string;
}

export const auditService = {
  async log(entry: AuditLogEntry): Promise<void> {
    try {
      // TODO: Re-enable when audit_logs table types are available
      // For now, just log to console for development
      console.log('Audit Log:', entry);
      return;
      
      // const { data: { user } } = await supabase.auth.getUser();
      // 
      // await supabase.from('audit_logs').insert({
      //   user_id: user?.id || entry.user_id,
      //   action: entry.action,
      //   resource_type: entry.resource_type,
      //   resource_id: entry.resource_id,
      //   metadata: entry.metadata,
      //   ip_address: entry.ip_address,
      //   user_agent: entry.user_agent || navigator.userAgent
      // });
    } catch (error) {
      console.error('Failed to log audit entry:', error);
    }
  },

  async getUserAuditLogs(limit: number = 50): Promise<any[]> {
    try {
      // TODO: Re-enable when audit_logs table types are available
      console.log('Getting audit logs (disabled for now)');
      return [];
      
      // const { data, error } = await supabase
      //   .from('audit_logs')
      //   .select('*')
      //   .order('created_at', { ascending: false })
      //   .limit(limit);
      //
      // if (error) throw error;
      // return data || [];
    } catch (error) {
      console.error('Failed to fetch audit logs:', error);
      return [];
    }
  }
};
